export default __webpack_public_path__ + "static/ba-left-new-6e2a8c52e426701da9b5621c2291d642.png";